import { paths } from "helpers/paths";
import React, { Component } from "react";
import { Redirect, Route, Switch } from "react-router-dom";
import * as historySource from "sources/books/trackerHistory";
import * as source from "sources/books/trackers";
import Form from "./form";
import { TrackerHistory, TrackerHistoryForm } from "./history";
import List from "./list";
import TrackerOdometerValues from "./odometerValues";
import Show from "./show";

export default class Trackers extends Component {
    componentWillUnmount() {
        this.props.clearParams("trackers");
    }

    render() {
        const { match, location, history, canEditBooks } = this.props;
        const rootUrl = `${match.path}/list`;
        const back = () => history.push(rootUrl);
        const moreProps = { ...this.props, onlyRoot: true };
        const backToHistory = (counterpartyId) => history.push(paths.trackerHistory(counterpartyId));
        return (
            <div className="page-content">
                <Switch location={location}>
                    <Route exact path={`${match.path}/`} render={() => <Redirect to={rootUrl} />} />
                    <Route
                        exact
                        path={rootUrl}
                        render={() => (
                            <List {...moreProps} isTable transition="full" nofilter title="Список трекеров" />
                        )}
                    />
                    <Route
                        exact
                        path={`${rootUrl}/:trackerId/history/new`}
                        render={(rest) => (
                            <TrackerHistoryForm
                                {...rest}
                                nofilter
                                transition="full"
                                title="Создание привязки трекера"
                                back={() => backToHistory(rest.match.params.trackerId)}
                                source={historySource}
                            />
                        )}
                    />
                    <Route
                        exact
                        path={`${rootUrl}/:trackerId/history/:id`}
                        render={(rest) => (
                            <TrackerHistoryForm
                                {...rest}
                                nofilter
                                transition="full"
                                title="Редактирование привязки трекера"
                                back={() => backToHistory(rest.match.params.trackerId)}
                                source={historySource}
                            />
                        )}
                    />
                    <Route
                        exact
                        path={`${rootUrl}/:trackerId/history`}
                        render={(rest) => (
                            <TrackerHistory
                                {...rest}
                                nofilter
                                transition="full"
                                title="История привязки трекера"
                                back={back}
                                source={historySource}
                            />
                        )}
                    />
                    <Route
                        exact
                        path={`${rootUrl}/:trackerId/odometer-values`}
                        render={(rest) => (
                            <TrackerOdometerValues
                                {...rest}
                                nofilter
                                transition="full"
                                title="Данные по одометру"
                                back={back}
                            />
                        )}
                    />
                    <Route
                        exact
                        path={`${rootUrl}/:id`}
                        render={(rest) => <Show {...rest} title="Трекер" back={back} source={source} />}
                    />
                    {canEditBooks() && (
                        <Route
                            path={`${match.path}/new`}
                            render={() => (
                                <Form {...moreProps} title="Создать трекер" back={back} submit={source.apply} />
                            )}
                        />
                    )}
                </Switch>
            </div>
        );
    }
}
